// Zod DTOs for the `/v1/exam-boards` authoring surface (spec §3.3 `ExamBoard`
// model, §3.5 "Dynamic boards & levels", §6.2) — the single source of truth
// consumed by `apps/api`'s route validators (`@hono/zod-validator`) and the
// `@hono/zod-openapi` document generator (P1-03 wires the actual routes;
// this package only owns the shapes). `position`/`isPublished`/`archivedAt`
// are never part of create/update bodies — they're server-managed via the
// dedicated `reorder`/`publish`/`unpublish`/archive(`DELETE`) endpoints.
import { z } from 'zod';
import {
  codeSchema,
  descriptionSchema,
  idSchema,
  reorderRequestSchema,
  slugSchema,
  titleSchema,
} from './primitives';

// ─── POST /v1/exam-boards ───────────────────────────────────────────────────

export const examBoardCreateRequestSchema = z.object({
  code: codeSchema,
  name: titleSchema,
  // "derived from name, editable" (spec §3.5) — optional on create; the
  // service derives one from `name` when omitted.
  slug: slugSchema.optional(),
  description: descriptionSchema,
  logoAssetId: idSchema.optional(),
});
export type ExamBoardCreateRequest = z.infer<typeof examBoardCreateRequestSchema>;

// ─── PATCH /v1/exam-boards/:id ──────────────────────────────────────────────

export const examBoardUpdateRequestSchema = examBoardCreateRequestSchema.partial();
export type ExamBoardUpdateRequest = z.infer<typeof examBoardUpdateRequestSchema>;

// ─── POST /v1/exam-boards/reorder ───────────────────────────────────────────

export const examBoardReorderRequestSchema = reorderRequestSchema;
export type ExamBoardReorderRequest = z.infer<typeof examBoardReorderRequestSchema>;
